function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import * as schedule from '@/api/schedule.js';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import { Debounce } from '@/utils/validate';
export default {
  name: 'CompanyList',
  data: function data() {
    return {
      tableData: {
        list: [],
        total: 0
      },
      loading: false,
      dialogVisible: false,
      editId: 0,
      tableFrom: {
        page: 1,
        limit: 20
      },
      searchForm: {
        jobId: '',
        beanName: '',
        methodName: '',
        nodeIp: '',
        dispatchStrategy: '',
        status: ''
      },
      statusOptions: [{
        label: '成功',
        value: 1
      }, {
        label: '失败',
        value: 0
      }],
      strategyOptions: [{
        label: '轮询调度',
        value: 'ROUND_ROBIN'
      }, {
        label: '权重轮询',
        value: 'WEIGHTED'
      }, {
        label: '分片广播',
        value: 'SHARDING'
      }]
    };
  },
  created: function created() {
    if (checkPermi(['admin:schedule:job:log:list'])) this.getjobLogList();
  },
  methods: {
    checkPermi: checkPermi,
    //  获取定时任务日志分页列表
    getjobLogList: function getjobLogList() {
      var _this = this;
      this.loading = true;
      schedule.jobLogList(_objectSpread({
        page: this.tableFrom.page,
        limit: this.tableFrom.limit
      }, this.normalizedSearchForm())).then(function (res) {
        _this.loading = false;
        _this.tableData = res || {
          list: [],
          total: 0
        };
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 分页
    pageChange: function pageChange(e) {
      this.tableFrom.page = e;
      this.getjobLogList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.tableFrom.limit = e;
      this.getjobLogList();
    },
    handleSearch: function handleSearch() {
      this.tableFrom.page = 1;
      this.getjobLogList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        jobId: '',
        beanName: '',
        methodName: '',
        nodeIp: '',
        dispatchStrategy: '',
        status: ''
      };
      this.handleSearch();
    },
    normalizedSearchForm: function normalizedSearchForm() {
      var payload = _objectSpread({}, this.searchForm);
      if (!payload.jobId) delete payload.jobId;
      if (!payload.beanName) delete payload.beanName;
      if (!payload.methodName) delete payload.methodName;
      if (!payload.nodeIp) delete payload.nodeIp;
      if (payload.status === '' || payload.status === null || payload.status === undefined) {
        delete payload.status;
      }
      if (!payload.dispatchStrategy) delete payload.dispatchStrategy;
      return payload;
    }
  },
  computed: {
    strategyMap: function strategyMap() {
      return this.strategyOptions.reduce(function (acc, cur) {
        acc[cur.value] = cur.label;
        return acc;
      }, {});
    }
  }
};